import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { COLLECTION_IDEMPOTENCY_OPERATION } from '../idempotency/collection-request-idempotency';
import { CollectionRequestIdempotencyService } from '../idempotency/collection-request-idempotency.service';

export const collectionIdempotencyInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const operation = req.context.get(COLLECTION_IDEMPOTENCY_OPERATION);

  if (!operation) {
    return next(req);
  }

  const collectionRequestIdempotency = inject(
    CollectionRequestIdempotencyService,
  );
  const key = collectionRequestIdempotency.getOrCreateKey(operation);

  return next(
    req.clone({
      setHeaders: {
        'Idempotency-Key': key,
      },
    }),
  );
};
